export default __webpack_public_path__ + "assets/logos/b0291b2f668eccc80d9e24b747d163cf.png";